export const NEW_MENU_PAGE_PATH = {
  MIGRATION_STATUS:
    'api/rs-aliados-gateway/rs-catalog-gateway-v2/rs-catalog-core/v1/stores/:storeId/migration-status',
  FULL_MENU:
    'api/rs-aliados-gateway/rs-catalog-gateway-v2/rs-catalog-core/v1/stores/:storeId/store-menu',
} as const;
